import { gray, grayDark } from '@tamagui/colors';
import { createV5Theme, defaultChildrenThemes, v5GrandchildrenThemes } from '@tamagui/themes/v5';
import { contextColors, contextColorsDark } from '../colors';
import * as buttonThemes from '../themes/button';

const {
  unistocks,
  unistocksAlt,
  bodyFont,
  headingFont,
  success,
  warning,
  danger,
  info,
  positive,
  negative
} = contextColors;

const {
  unistocks: unistocksDark,
  unistocksAlt: unistocksAltDark,
  bodyFont: bodyFontDark,
  headingFont: headingFontDark,
  success: successDark,
  warning: warningDark,
  danger: dangerDark,
  info: infoDark,
  positive: positiveDark,
  negative: negativeDark
} = contextColorsDark;

let themesV5 = createV5Theme({
  childrenThemes: {
    ...defaultChildrenThemes,
    unistocks: {
      light: { unistocks },
      dark: { unistocks: unistocksDark }
    },
    unistocksAlt: {
      light: { unistocksAlt },
      dark: { unistocksAlt: unistocksAltDark }
    },
    bodyFont: {
      light: { bodyFont },
      dark: { bodyFont: bodyFontDark }
    },
    headingFont: {
      light: { headingFont },
      dark: { headingFont: headingFontDark }
    },
    success: {
      light: { success },
      dark: { success: successDark }
    },
    warning: {
      light: { warning },
      dark: { warning: warningDark }
    },
    danger: {
      light: { danger },
      dark: { danger: dangerDark }
    },
    info: {
      light: { info },
      dark: { info: infoDark }
    },
    positive: {
      light: { positive },
      dark: { positive: positiveDark }
    },
    negative: {
      light: { negative },
      dark: { negative: negativeDark }
    }
  },
  grandChildrenThemes: {
    ...v5GrandchildrenThemes,
    surface3: {
      template: 'surface3'
    }
  }
  // componentThemes: false
});

// TODO: Better way to customize specific values
themesV5.light_blue.placeholderColor = gray.gray8;
themesV5.dark_blue.placeholderColor = grayDark.gray10;

themesV5 = {
  ...themesV5,
  ...buttonThemes
};

export type TamaguiThemes = typeof themesV5;

/**
 * This is an optional production optimization: themes JS can get to 20Kb or more.
 * Tamagui has ~1Kb of logic to hydrate themes from CSS, so you can remove the JS.
 * So long as you server render your Tamagui CSS, this will save you bundle size:
 */
export const themes: TamaguiThemes =
  process.env.TAMAGUI_ENVIRONMENT === 'client' && process.env.NODE_ENV === 'production'
    ? ({} as TamaguiThemes)
    : themesV5;
